import Password from './index'
export default [
  {
    path: '/change/password',
    name: 'safe-change-password',
    component: Password
  },
]
